const ENV = process.env.REACT_APP_ENV;
const appConfig = {
  APP_ID: process.env.REACT_APP_ID,
  SSO_URL: process.env.REACT_APP_SSO_API_URL,
  API_URL: process.env.REACT_APP_API_URL,
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  MCONNECT_URL: process.env.REACT_APP_MCONNECT_URL,
  EBASE_URL: process.env.REACT_APP_EBASE_URL,
  LOCATION_API_URL: process.env.REACT_APP_LOCATION_API,
  LOCATION_API_SECRET_KEY: process.env.REACT_APP_LOCATION_API_ACCESS,
  MAP_BOX_API_URL: process.env.REACT_APP_MAP_BOX_API_URL,
  MAP_BOX_GEOCODING_URL: process.env.REACT_APP_MAP_BOX_GEOCODING_URL,
  MAP_BOX_API_TOKEN: process.env.REACT_APP_MAP_BOX_API_TOKEN,
  MANPOWER_POLICY_URL: process.env.REACT_APP_MANPOWER_POLICY_URL,
  MANPOWER_ELEAVE_HRSS: process.env.REACT_APP_MANPOWER_ELEAVE_HRSS,
};

export const config = { ...appConfig };
